export default "__VITE_ASSET__DuWOQpOI__"